// Restore animation trigger immediately
document.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("is-loaded");
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.muted = true;
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    this.reducedMotion.addEventListener("change", () => {
      if (this.slider.getAttribute("data-autoplay") === "true")
        this.setAutoPlay();
    });

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (
      this.querySelector(".announcement-bar-slider").contains(event.target)
    ) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    // Filter Slick Slider based on variant selection
    try {
      if (window.jQuery) {
        const slider = window.jQuery('.main-product-section__slider');
        const thumbnails = window.jQuery('.main-product-section__thumbnails');
        
        if (slider.length && slider.hasClass('slick-initialized')) {
          const selectedOptions = this.options.filter(Boolean).map(opt => opt.toLowerCase());
          
          slider.slick('slickUnfilter');
          thumbnails.slick('slickUnfilter');
          
          const filterFunc = function() {
            const color = window.jQuery(this).attr('data-color');
            return !color || selectedOptions.includes(color);
          };
          
          const matchingSlides = slider.find('.slick-slide').filter(filterFunc);
          // Only filter if we actually have matching slides for this variant, to avoid empty galleries
          if (matchingSlides.length > 0 && matchingSlides.length < slider.find('.slick-slide').length) {
            slider.slick('slickFilter', filterFunc);
            thumbnails.slick('slickFilter', filterFunc);
            slider.slick('slickGoTo', 0);
          }
        }
      }
    } catch (e) {
      console.error("Error filtering slick slider:", e);
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value"),
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden"),
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === "",
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`,
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut,
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : "";
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

$(document).ready(() => {
  if ($(window).width() > 750) {
    $(".facets.sort--mobile").remove();
  }

  let currentURL = window.location.href;

  const $dropdown = $(".custom-dropdown");
  const $toggle = $dropdown.find(".dropdown-toggle");
  const $menu = $dropdown.find(".dropdown-menu");
  if (window.location.pathname === "/account") {
    $toggle
      .text("Dealer details")
      .append(
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '        <mask id="mask0_1590_14218" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">\n' +
          '          <path d="M1.90735e-06 -1.04907e-06L8.58275e-07 24L24 24L24 0L1.90735e-06 -1.04907e-06Z" fill="white"/>\n' +
          "        </mask>\n" +
          '        <g mask="url(#mask0_1590_14218)">\n' +
          '          <path d="M17 10L13.335 14.3445C12.5977 15.2185 11.4023 15.2185 10.665 14.3445L7 10" stroke="#ED5718" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
          "        </g>\n" +
          "      </svg>",
      );
  } else if (currentURL.indexOf("?order") !== -1) {
    $toggle
      .text("Dealer orders")
      .append(
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '        <mask id="mask0_1590_14218" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">\n' +
          '          <path d="M1.90735e-06 -1.04907e-06L8.58275e-07 24L24 24L24 0L1.90735e-06 -1.04907e-06Z" fill="white"/>\n' +
          "        </mask>\n" +
          '        <g mask="url(#mask0_1590_14218)">\n' +
          '          <path d="M17 10L13.335 14.3445C12.5977 15.2185 11.4023 15.2185 10.665 14.3445L7 10" stroke="#ED5718" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
          "        </g>\n" +
          "      </svg>",
      );
  } else if (window.location.pathname === "/account/addresses") {
    $toggle
      .text("DEALER ADDRESSES")
      .append(
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '        <mask id="mask0_1590_14218" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">\n' +
          '          <path d="M1.90735e-06 -1.04907e-06L8.58275e-07 24L24 24L24 0L1.90735e-06 -1.04907e-06Z" fill="white"/>\n' +
          "        </mask>\n" +
          '        <g mask="url(#mask0_1590_14218)">\n' +
          '          <path d="M17 10L13.335 14.3445C12.5977 15.2185 11.4023 15.2185 10.665 14.3445L7 10" stroke="#ED5718" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
          "        </g>\n" +
          "      </svg>",
      );
  }
  // Открытие/закрытие меню
  $toggle.on("click", function () {
    $dropdown.toggleClass("open");
  });

  // Изменение текста на выбранный пункт
  $menu.find("a").on("click", function (e) {
    e.preventDefault();
    const $link = $(this);
    const text = $link.text();
    const href = $link.attr("href");

    $toggle.text(text).append('<span class="arrow"></span>'); // Обновляем текст
    $dropdown.removeClass("open"); // Закрываем меню

    if (href) {
      window.location.href = href; // Переход на страницу
    }
  });

  // Закрытие при клике вне области
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".custom-dropdown").length) {
      $dropdown.removeClass("open");
    }
  });

  if (currentURL.indexOf("?order") !== -1) {
    $(".account-content[data-account]").hide();
    $(".account-content[data-orders]").show();

    $(".account-nav ul li a").removeClass("active");
    $(".order-link").addClass("active");

    $(".customer").addClass("orders");
  } else {
    $(".account-content[data-account]").show();
    $(".account-content[data-orders]").hide();

    $(".order-link").removeClass("active");
    $(".customer").removeClass("orders");
  }

  const params = new URLSearchParams(window.location.search);

  if (params.has("id")) {
    $(".account-content[data-account]").hide();
    $(".account-content[data-orders]").show();

    $(".account-nav ul li a").removeClass("active");
    $(".order-link").addClass("active");
    const url = window.location.href;
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    console.log("id:", id);
    $(`.account-content[data-orders]`).hide();
    $(`.account-orders--second[data-id=${id}]`).show();
  }

  let initialized = false;

  var target = $(".main-product-section__info");
  var blockToShow = $(".fixed-form-pdp");

  if ($(window).width() < 460) {
    // При клике на заголовок h2
    $(".footer-block__heading").click(function () {
      $(this).parent(".footer-block").toggleClass("active");

      $(this).siblings(".footer-block__details-content").slideToggle();
    });
  }

  blockToShow.hide();
  if (window.location.pathname.includes("/products")) {
    $(window).scroll(function () {
      checkVisibility();
    });

    $(window).resize(function () {
      checkVisibility();
    });
  }

  function checkVisibility() {
    var windowWidth = $(window).width();

    if (windowWidth < 981) {
      blockToShow.show();
    } else {
      if (!isInView(target)) {
        blockToShow.fadeIn();
      } else {
        blockToShow.fadeOut();
      }
    }
  }

  function isInView(element) {
    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();
    var elementTop = element.offset().top;
    var elementBottom = elementTop + element.height();

    return elementBottom > windowTop && elementTop < windowBottom;
  }

  if (window.location.pathname.includes("/products")) {
    checkVisibility();
  }

  function progress(sliders) {
    sliders.each(function () {
      let slider = jQuery(this);
      let $progressBar = slider.next();

      if (!initialized) {
        let slick = slider.slick("getSlick");
        let initialCalc = (1 / slick.slideCount) * 100;
        $progressBar.css("background-size", initialCalc + "% 100%");
        initialized = true; // Устанавливаем флаг
      }

      slider.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          let calc = ((nextSlide + 1) / slick.slideCount) * 100;
          $progressBar.css("background-size", calc + "% 100%");
        },
      );
    });
  }

  let initializedSecond = false;

  function progressWithLine(sliders, line) {
    sliders.each(function () {
      var slider = jQuery(this);
      var $progressBar = line;
      console.log("$progressBar:", $progressBar);

      if (!initializedSecond) {
        let slick = slider.slick("getSlick");
        let initialCalc = (1 / slick.slideCount) * 100;
        $progressBar.css("background-size", initialCalc + "% 100%");
        initialized = true;
      }

      slider.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          var calc = ((nextSlide + 1) / slick.slideCount) * 100;
          $progressBar.css("background-size", calc + "% 100%");
        },
      );
    });
  }

  $(".main-product-section__slider").slick({
    asNavFor: $(".main-product-section__thumbnails"),
    slidesToShow: 1,
    arrows: true,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 19L8 12L15 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5L16 12L9 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
  });

  $(".main-product-section__thumbnails").slick({
    vertical: true,
    slidesToShow: 5,
    asNavFor: $(".main-product-section__slider"),
    arrows: false,
    infinite: false,
    focusOnSelect: true,
    draggable: false,
    verticalSwiping: false,
    responsive: [
      {
        breakpoint: 981,
        settings: {
          slidesToShow: 4,
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".main-product-section__media-feature__sliders").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 981,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  if (window.location.pathname.includes("/products")) {
    progress($(".main-product-section__media-feature__sliders"));

    progressWithLine(
      $(".main-product-section__slider"),
      $(".product-grid__line[data-main]"),
    );

    if ($(window).width() < 990) {
      // Сначала показываем только первые 4 продукта
      var productsToShow = 4;
      var totalProducts = $(".recommendation-product").length;

      // Скрываем все продукты, начиная с 5-го
      $(".recommendation-product").slice(productsToShow).hide();

      // При клике на кнопку показываем все продукты и скрываем кнопку
      $(document).on("click", ".recommendations-products__more", function () {
        $(".recommendation-product:hidden").fadeIn(); // Плавно показываем скрытые продукты
        $(this).hide(); // Скрываем кнопку
      });
    }
  }
  $(".faq-item:first-child")
    .toggleClass("active")
    .find(".faq-item__body")
    .slideToggle();

  $(".faq-item").on("click", function () {
    const $th = $(this);

    // Закрываем все другие элементы
    $(".faq-item")
      .not($th)
      .removeClass("active")
      .find(".faq-item__body")
      .slideUp();

    // Открываем или закрываем текущий элемент
    $th.toggleClass("active").find(".faq-item__body").slideToggle();
  });

  function toggleContent() {
    if ($("[data-table]").hasClass("active")) {
      $(".main-product-section__media-table__content").show(); // Показать таблицу
      $(".main-product-section__media-document__content").hide(); // Скрыть документы
    } else if ($("[data-document]").hasClass("active")) {
      $(".main-product-section__media-document__content").show(); // Показать документы
      $(".main-product-section__media-table__content").hide(); // Скрыть таблицу
    }
  }

  // Вызов функции при загрузке страницы
  toggleContent();

  // Обработка кликов по элементам с атрибутами data-table и data-document
  $("[data-table]").on("click", function () {
    $("[data-table]").addClass("active");
    $("[data-document]").removeClass("active");
    toggleContent();
  });

  $("[data-document]").on("click", function () {
    $("[data-document]").addClass("active");
    $("[data-table]").removeClass("active");
    toggleContent();
  });

  $(".main-product-section__media-table__row").slice(5).hide();

  // Обрабатываем клик по кнопке "Load more"
  $(".main-product-section__media-table__load").click(function () {
    let button = $(this);
    let hiddenRows = $(".main-product-section__media-table__row").slice(5);

    if (hiddenRows.is(":visible")) {
      // Если строки видны, скрываем их и меняем текст на "Load more"
      hiddenRows.slideUp();
      button.text("Load more");
    } else {
      // Если строки скрыты, показываем их и меняем текст на "Hide"
      hiddenRows.slideDown();
      button.text("Hide");
    }
  });

  if ($(window).width() <= 981) {
    $(".desctop-picker").remove();

    $(".home-features__slider").each(function () {
      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: $(this).next().next(),
        nextArrow: $(this).next().next().next(),
      });
    });
    $(".brands-wrapper").slick({
      slidesToShow: 2,
      infinite: true,
      arrows: false,
    });
    $(".home-blog .blog-listing").slick({
      slidesToShow: 1,
      infinite: true,
      arrows: false,
    });
    progress($(".home-blog .blog-listing"));
  } else {
    $(".main-product-section__info--mobile .mobile-picker").remove();
    $(".brands-wrapper").slick({
      slidesToShow: 4,
      infinite: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 981,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
    $(".home-features__slider").each(function () {
      $(this).slick({
        slidesToShow: 3,
        infinite: true,
        prevArrow: $(this).next().next(),
        nextArrow: $(this).next().next().next(),

        responsive: [
          {
            breakpoint: 981,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
  }

  $(".marquee__inner").slick({
    centerMode: true,
    slidesToScroll: 1,
    variableWidth: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,

    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    infinite: true,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 981,
        settings: {
          speed: 8000,
        },
      },
    ],
  });
  if (window.location.pathname.includes("/")) {
    progress($(".home-features__slider"));
  }

  $(".home-features__slider-wrapper").hide();
  $(".product-grid__line").hide();

  $(".home-features__titles span:first-child").addClass("active");
  $(".home-features__slider-wrapper:first-child").show();
  $(".home-features__slider-wrapper:first-child .home-features__slider")
    .next()
    .show();

  $(".home-features__titles span").on("click", function () {
    const $th = $(this);
    const block = $th.attr("data-block");
    $(".home-features__slider-wrapper").hide();
    $(".product-grid__line").hide();
    $(".home-features__titles span").removeClass("active");

    $(`.home-features__titles span[data-block=${block}]`).addClass("active");
    $(`.home-features__slider-wrapper[data-block=${block}]`).show();
    $(`.product-grid__line[data-block=${block}]`).show();

    $(`.home-features__slider[data-block=${block}]`).slick("refresh");
  });

  if ($(window).width() <= 981) {
    $(".section-tips__left").slick({});

    if (window.location.pathname.includes("/")) {
      progressWithLine(
        $(".section-tips__left"),
        $(".tip-grid__line[data-line]"),
      );
    }
  }

  if (window.location.pathname === "/pages/about-us-1") {
    $(".about-brands__wrapper").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 981,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    progress($(".about-brands__wrapper"));

    if ($(window).width() < 1081) {
      $(".about-points__wrapper").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
      });
      initialized = false;
      progress($(".about-points__wrapper"));
    }
  }

  if (window.location.pathname === "/pages/contact-us-1") {
    var path = new URLSearchParams(window.location.search);

    // Проверяем, есть ли параметр contact_posted со значением true
    if (path.get("contact_posted") === "true") {
      console.log("Параметр contact_posted=true найден в URL");
      setTimeout(() => {
        $(window).scrollTop(0);
      }, 500);

      $(".contact_form_success").addClass("show");

      $("#ContactForm").hide();
    }
  }
  if (window.location.pathname === "/pages/warranty") {
    $(".warranty-brands__list").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 981,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  if (
    window.location.pathname ===
      "/pages/privacy-policy-and-terms-and-conditions" ||
    window.location.pathname === "/pages/shipping-and-return"
  ) {
    $(".generic-tabs li").on("click", function () {
      const $th = $(this);
      let blockId = $th.attr("data-block");
      $(".generic-tabs li").removeClass("active");
      $th.addClass("active");

      $(".generic-rta").removeClass("active");
      $(`.generic-rta[data-block=${blockId}]`).addClass("active");
    });

    $(".dropdown-header").on("click", function () {
      $(this).next(".dropdown-list").toggle();
    });

    // Выбор пункта и вывод в консоль
    $(".dropdown-list li").on("click", function () {
      const selectedText = $(this).text(); // Текст выбранного пункта
      const selectedValue = $(this).data("block"); // Значение из data-value
      console.log(`Вы выбрали: ${selectedText} (значение: ${selectedValue})`);
      $(".generic-rta").removeClass("active");

      $(`.generic-rta[data-block=${selectedValue}]`).addClass("active");

      // Обновляем заголовок dropdown
      $(this)
        .closest(".custom-dropdown")
        .find(".dropdown-header")
        .html(
          selectedText +
            `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_1148_20569" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
<path d="M1.90735e-06 -1.04907e-06L8.58275e-07 24L24 24L24 0L1.90735e-06 -1.04907e-06Z" fill="white"/>
</mask>
<g mask="url(#mask0_1148_20569)">
<path d="M17 10L13.335 14.3445C12.5977 15.2185 11.4023 15.2185 10.665 14.3445L7 10" stroke="#ED5718" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`,
        );

      // Закрываем dropdown
      $(this).parent(".dropdown-list").hide();
    });

    // Закрытие dropdown при клике вне
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".custom-dropdown").length) {
        $(".dropdown-list").hide();
      }
    });
  }

  if (window.location.pathname === "/pages/bulk-order") {
    $(".js-add-bulk-row").on("click", function () {
      $(".inputs").append(`<div class="row">
                          <div class="inputs-left">
                            <select class="sku-input" placeholder="Item #" type="text" name="sku"></select>
                          </div>
                          <div class="inputs-right">
                            <quantity-input class="quantity">
  <button class="quantity__button disabled" name="minus" type="button">–
  </button>
  <input class="quantity__input" type="number" name="quantity" value="1" min="1">
  <button class="quantity__button" name="plus" type="button">+
  </button>
</quantity-input>


                          </div>
                        </div>`);
    });
  }

  if (window.location.pathname === "/pages/wholesale-registration-form") {
    $(".wsg-second-step .wsg-nav-prev").on("click", function () {
      $(".wsg-first-step").show();
      $(".wsg-second-step").hide();
    });

    $(".wsg-third-step .wsg-nav-prev").on("click", function () {
      $(".wsg-second-step").show();
      $(".wsg-third-step").hide();
    });

    // wsg-first-step
    $(".wsg-first-step .wsg-nav-next").on("click", function () {
      let isValid = true; // флаг валидности

      // Проверяем поле с id="nameInput"
      const nameInput = $("#first_name").val().trim();
      if (nameInput === "") {
        isValid = false;
        alert("First name is required");
        // $('#wsg-signup').submit()
      }

      const lastNameInput = $("#last_name").val().trim();
      if (lastNameInput === "") {
        isValid = false;
        alert("Last name is required");
        // $('#wsg-signup').submit()
      }

      // Проверяем поле с id="emailInput"
      const emailInput = $("#email").val().trim();
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/; // регулярное выражение для email
      if (!emailPattern.test(emailInput)) {
        isValid = false;
        alert("Enter correct email");
      }
      // $('#wsg-submit').click();
      // Если все проверки пройдены, выполняем действие (например, отправляем форму)
      if (isValid) {
        $(".wsg-first-step").hide();
        $(".wsg-second-step").show();
      }
    });

    // wsg-second-step
    $(".wsg-second-step .wsg-nav-next").on("click", function () {
      let isValid = true; // флаг валидности

      // Получаем значение поля
      const zipCode = $("#wsg-form-zip").val().trim();

      // Регулярное выражение для проверки
      const zipCodePattern = /^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/;

      if (!zipCodePattern.test(zipCode)) {
        isValid = false;
        alert("Enter correct zip code of Canada (example, A1A 1A1)");
      }

      // Если почтовый код валиден
      if (isValid) {
        $(".wsg-second-step").hide();
        $(".wsg-third-step").show();
      }
    });
  }

  $(".main-product-section__media-table__row").each(function () {
    const secondCol = $(this)
      .find(".main-product-section__media-table__col")
      .eq(0);

    const originalText = secondCol.text();

    const updatedText = originalText.replace(/_/g, " ");
    secondCol.text(updatedText);
  });

  if ($(".main-product-section__media-table__row").length > 0) {
    $(".main-product-section__media-table__load").show();
  } else {
    $(".main-product-section__media-table__content").append(
      `<span>No more information</span>`,
    );
    $(".main-product-section__media-table__load").hide();
  }
  if (window.location.href.indexOf("blogs") !== -1) {
    $(`.active-checkbox[data-link="${window.location.pathname}"]`).show();
    $(`.active-checkbox[data-link="${window.location.pathname}"]`)
      .next()
      .hide();

    $(document).on("click", "h4.toggle", function () {
      const $th = $(this);
      const $svg = $th.find("svg");

      if ($svg.attr("data-rotated") === "true") {
        // Возвращаем в исходную позицию
        $th.css("color", "#ED5718");
        $svg.css("transform", "rotate(0deg)");
        $svg.attr("data-rotated", "false"); // Устанавливаем атрибут в false
      } else {
        // Поворачиваем на 180 градусов
        $th.css("color", "rgba(35, 35, 35, 1)");
        $svg.css("transform", "rotate(180deg)");
        $svg.attr("data-rotated", "true"); // Устанавливаем атрибут в true
      }

      $th.next().slideToggle("slow");
    });
  }
  $(".brand-slider__list").slick({
    slidesToShow: 3,
    infinite: true,
    prevArrow: $(this).next().next(),
    nextArrow: $(this).next().next().next(),

    responsive: [
      {
        breakpoint: 981,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  progress($(".brand-slider__list"));

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  function handleUrlChange() {
    const params = new URLSearchParams(window.location.search);
    const variant = params.get("variant"); // Get the 'variant' parameter

    if (variant !== null) {
      const input = document.getElementById("current-variant-id");
      if (input) {
        input.value = variant;
      }
    }
  }

  history.pushState = function (...args) {
    originalPushState.apply(this, args);
    handleUrlChange();
  };

  history.replaceState = function (...args) {
    originalReplaceState.apply(this, args);
    handleUrlChange();
  };

  window.addEventListener("popstate", handleUrlChange);

  // Run once on page load in case the query param is already present
  document.addEventListener("DOMContentLoaded", handleUrlChange);
  if (
    window.location.href.indexOf(
      "?contact%5Btags%5D=newsletter&form_type=customer#ContactFooter",
    ) !== -1
  ) {
    $(".newsletter-form__success").addClass("active");
  }

  $(".video-section__slider").slick({
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 1000,
    fade: true,
    slide: "div",
    cssEase: "linear",
  });
});
